<template>
    <footer>
        <div class="information">
            <div class="text">
                <img src="../assets/images/logo-footer.png" alt="Vilavella Hotel Boutique">
                <h2>{{this.current_lang.home[14]}}</h2>
                <a href="https://www.waze.com/ul?ll=13.59570000%2C-89.82708940&navigate=yes" target="_blank">{{this.current_lang.home[15]}}</a>
                <a href="mailto:info@villavela.com">info@hotelvillavela.com</a>
                <a href="tel:(503)24526910">(503) 2452 6910</a>
                <div class="form">
                    <form class="form-villavela" action="contact" v-on:submit.prevent>
                        <input name="name" type="text" :placeholder="this.current_lang.home[16]" required="required">
                        <input name="email" type="text" placeholder="@mail.com" required="required">
                        <input name="phone" type="number" :placeholder="this.current_lang.home[17]" required="required">
                        <input name="nel" type="text" placeholder="Nel">
                        <textarea name="message" :placeholder="this.current_lang.home[18]" required="required"></textarea>
                        <button class="easeOutCubic">{{this.current_lang.home[19]}} <i class="fas fa-anchor"></i> <i id="rotating" class="fa fa-spinner faa-spin"></i></button>
                    </form>
                </div>
            </div>
            <Social></Social>
        </div>
        <div class="background"></div>
        <div class="copyright">
            <a href="http://www.fondepro.gob.sv/"  target="_blank" rel="noopener" class="fondepro">
                <img src="../assets/images/fondepro.png" class="easeOutCubic" alt="Fondepro | Fondo de desarrollo productivo" >
                <p>{{this.current_lang.home[20]}}</p>
            </a>
            <h4>Powered by <a href="http://lafabrica.agency" target="_blank" rel="noopener">LaFábrica</a> / Copyright Villavela Hotel Boutique.</h4>
        </div>
    </footer>
</template>



<script>
import Social from '@/components/Social.vue'
import {mapState} from 'vuex';
export default {
    name: 'Footer',
    data() {
        return {
            langs: null,
            current_lang : null,
        }
    },
    created() {

        // lang

        var url =  window.location.href;

        url = url.split('/');

        url.forEach(element => {
           if(element === 'es'){
               this.langs = 'es';
           }else if(element === 'en'){
               this.langs = 'en';
           }
        });

        if(this.langs === null)
            this.langs = 'es';

        this.current_lang = this.lang.es;

        if(this.langs){
            if(this.langs === 'es'){
                this.current_lang = this.lang.es;
            }else if(this.langs === 'en'){
                this.current_lang = this.lang.en;
            }
        }

    },
    components: {
        Social
    },
    computed: {
        ...mapState(['lang'])
    },
    mounted() {
        $('.form-villavela').on('submit', function (e) {

            e.preventDefault();

            $(this).find('button').addClass('submit');

            var that = $(this);
            
            var action = $(this).attr('action');

            var date = new Date();
            
            var form_subject = null;

            var form_room = null;
            
            var form_html = `<table><tbody>`;

            if(action === 'contact'){

                form_subject = 'Formulario Contáctenos';

                form_html  += `
                    <tr>
                        <td><b>Nombre: </b></td>
                        <td>`+$(this).find('input[name=name]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Correo: </b></td>
                        <td>`+$(this).find('input[name=email]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Teléfono: </b></td>
                        <td>`+$(this).find('input[name=phone]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Mensaje: </b></td>
                        <td>`+$(this).find('textarea[name=message]').val()+`</td>
                    </tr>
                `;
            }
            // else if(action === 'reserve'){

            //     form_subject = 'Formulario Reservación';

            //     form_room = $(this).attr('room');

            //     form_html  += `
            //         <tr>
            //             <td><b>Nombre: </b></td>
            //             <td>`+$(this).find('input[name=name]').val()+`</td>
            //         </tr>
            //         <tr>
            //             <td><b>Correo: </b></td>
            //             <td>`+$(this).find('input[name=email]').val()+`</td>
            //         </tr>
            //         <tr>
            //             <td><b>Teléfono: </b></td>
            //             <td>`+$(this).find('input[name=phone]').val()+`</td>
            //         </tr>
            //         <tr><td></td></tr>
            //         <tr><td></td></tr>
            //         <tr>
            //             <td><b>Habitación:</b></td>
            //             <td>`+form_room+`</td>
            //         </tr>
            //         <tr>
            //             <td><b>Fecha:</b></td>
            //             <td>`+$('form.date').find('input[name=day]').val()+`/`+$('form.date').find('input[name=month]').val()+`/`+date.getFullYear()+`</td>
            //         </tr>
            //         <tr>
            //             <td><b>Personas:</b></td>
            //             <td>`+$('form.date').find('input[name=people]').val()+`</td>
            //         </tr>
            //         <tr>
            //             <td><b>Estadía:</b></td>
            //             <td>`+$('form.date').find('input[name=day-stay]').val()+`</td>
            //         </tr>
            //     `;
            // }

            form_html += `</tbody></table>`;

            $.post( "https://hotelvillavela.com/mail.php", { subject: form_subject, html:  form_html})
            .done(function( data ) {
                // alert( "Data Loaded: " + data );
                setTimeout(() => {
                    that.find('button').removeClass('submit');
                    that[0].reset();
                }, 3000);
            });

        });
    },
}
</script>